import React, { Component } from 'react';
import InputGradesFilterStudents from '../../../StudentService/StudentServiceInputGrades/InputGradesFilterStudents';

class StudentFilterInputGrades extends Component {

    componentDidMount() {
        localStorage.setItem('redirectType', 'inputGrades');
    }

    render() {
        return (
            <div>
                <h1>Unos ocjena</h1>
                <InputGradesFilterStudents
                    redirectType="inputGrades"
                />
            </div>
        );
    }
}

export default StudentFilterInputGrades;



// WEBPACK FOOTER //
// ./src/views/Admin/Students/InputGrades/StudentFilterInputGrades.js